/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import { TableCell } from "@material-ui/core";
import { Text } from "UpduoLibrary";

import { useSelector } from "react-redux";
import { RootState } from "store/types";

import MemberProxyRow from "./MemberProxyRow";
import {
  skaleBlack,
  upduoMediumLightGray,
  skaleWhite,
} from "config/UpduoColors";
import { getNodes } from "config/Utilities";
import MemberTableBase from "../MemberTableBase";

export default function MemberProxyTable() {
  const unregisteredUserproxiesList = useSelector(
    (state: RootState) => state.unregisteredUserproxiesList
  );

  const columnHeaderArray = [
    "",
    "NAME",
    "TITLE",
    "ID",
    "EMAIL",
    "REGION",
    "DISTRICT",
    "STORE",
    "HIRE DATE",
  ];

  const columnHeaders = columnHeaderArray.map((item, itemIndex) => (
    <TableCell
      key={itemIndex + columnHeaderArray.length}
      style={{
        color: skaleBlack,
        backgroundColor: skaleWhite,
      }}
    >
      <View style={{ height: 40, justifyContent: "center" }}>
        <Text style={{ color: upduoMediumLightGray }}>{item}</Text>
      </View>
    </TableCell>
  ));

  return (
    <MemberTableBase
      headers={columnHeaders}
      body={getNodes(unregisteredUserproxiesList).map(
        (user, userIndex: number) => (
          <MemberProxyRow
            key={userIndex}
            rowData={user}
            userIndex={userIndex}
          />
        )
      )}
    />
  );
}
